import { Box, Typography, Button } from '@mui/material';
import icon_mini_chat_fold from '@images/icon_mini_chat_fold.png';
import icon_mini_chat_close from '@images/icon_mini_chat_close.png';
import { ASSIGNED, REQUESTED } from '@constants';

const CustomHeader = ({ styles, t, requestId, requestStatus, endChat, handleFoldClick, handleCloseClick }) => {
  return (
    <Box sx={styles.header}>
      <Box sx={{ display: 'flex' }}>
        <Typography style={styles.headerTitle}>{t('4530_chat_common.hyundai_assistant')}</Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        <Button sx={{ padding: 0, minWidth: 0 }} onClick={handleFoldClick}>
          <img style={{ width: '32px' }} src={icon_mini_chat_fold} alt="Fold Chat" />
        </Button>

        {(requestStatus === REQUESTED || requestStatus === ASSIGNED) && requestId && (
          <Button sx={styles.headerCloseButton} onClick={handleCloseClick}>
            <img style={{ width: '16px' }} src={icon_mini_chat_close} alt="Close Chat" />
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CustomHeader;
